"use client";

import { useEffect } from "react";

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    // Chunk load error → auto reload 1 lần
    if (
      error.message?.includes("Loading chunk") ||
      error.message?.includes("Cannot read properties of undefined") ||
      error.message?.includes("Failed to fetch dynamically imported module")
    ) {
      const key = "chunk-reload";
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        return;
      }
      sessionStorage.removeItem(key);
    }
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
      <p className="text-[14px] font-semibold text-[#0f172a]">Đã có lỗi xảy ra</p>
      <p className="text-[12px] text-[#64748b]">Thường do phiên bản cũ. Thử tải lại trang.</p>
      <button onClick={() => window.location.reload()}
        className="px-5 py-2.5 rounded-xl bg-teal-800 text-white text-[13px] font-bold hover:bg-teal-700">
        Tải lại trang
      </button>
    </div>
  );
}